export default __webpack_public_path__ + "static/media/zertiassist_iconos_templates_24px.654955b5.svg";